let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1P7Wr")).then(() => parcelRequire('eUUjP'));